export let acountList = '/index/acountList/1/账号/-1'
export default {
    acountList
}


// WEBPACK FOOTER //
// ./src/router/default.js